import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({
  scale,
  verticalOffset = 0,
  gradientStop1 = '#A77C54',
  gradientStop2 = '#291F19',
}) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`
  const transformOrigin = '25.52 9.66'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <g opacity="0.9">
        <path
          opacity="0.9"
          d="M18.1404 15.38C15.3104 17.07 11.6504 17.13 8.82037 15.52C5.12037 13.42 4.29035 8.94004 4.11035 6.53004C4.17035 5.15004 4.85034 3.01003 8.47034 2.64003C13.7103 2.11003 21.1204 3.35001 22.2004 8.00001C22.1704 11.21 20.7404 13.83 18.1404 15.38Z"
          fill={`url(#${randomGradientId1})`}
        />
      </g>
      <g opacity="0.9">
        <path
          opacity="0.9"
          d="M42.2501 15.52C39.4201 17.13 35.7601 17.07 32.9301 15.38C30.3301 13.83 28.9101 11.21 28.8701 8.00002C29.9501 3.35002 37.3601 2.11005 42.6001 2.65005C46.2101 3.02005 46.9001 5.16006 46.9601 6.54006C46.7901 8.95006 45.9501 13.42 42.2501 15.52Z"
          fill={`url(#${randomGradientId2})`}
        />
      </g>
      <path
        d="M3.68002 4.97009C3.68002 4.97009 3.18003 12.8401 8.62003 15.9301C14.25 19.1301 22.76 15.8901 22.57 7.69006"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M22.8501 7.17004C22.8501 7.17004 25.1901 6.07004 28.1901 7.17004"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M4.18018 7.79008C4.18018 7.79008 3.0602 3.28014 8.4502 2.73014C13.7702 2.19014 21.3302 3.47007 22.2402 8.28007C22.2402 8.28007 23.0002 8.40012 23.2402 7.83012C23.4802 7.26012 23.0802 2.69004 14.5602 1.37004C7.10018 0.210035 0.660156 1.39005 0.660156 1.39005L0.800171 3.78007C0.800171 3.78007 1.44019 4.16005 1.94019 5.26005C2.21019 5.87005 2.32018 7.98008 4.18018 7.79008Z"
        fill="#231F20"
      />
      <path
        d="M2.34027 3.45007C2.68269 3.45007 2.96027 3.17249 2.96027 2.83008C2.96027 2.48766 2.68269 2.21008 2.34027 2.21008C1.99785 2.21008 1.72021 2.48766 1.72021 2.83008C1.72021 3.17249 1.99785 3.45007 2.34027 3.45007Z"
        fill="white"
      />
      <path
        d="M47.3501 4.97009C47.3501 4.97009 47.8501 12.8401 42.4101 15.9301C36.7801 19.1301 28.2702 15.8901 28.4602 7.69006"
        stroke="white"
        strokeWidth="0.75"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M46.8502 7.79008C46.8502 7.79008 47.9702 3.28014 42.5802 2.73014C37.2602 2.19014 29.7002 3.47007 28.7902 8.28007C28.7902 8.28007 28.0302 8.40012 27.7902 7.83012C27.5502 7.26012 27.9502 2.69004 36.4702 1.37004C43.9302 0.210035 50.3702 1.39005 50.3702 1.39005L50.2302 3.78007C50.2302 3.78007 49.5902 4.16005 49.0902 5.26005C48.8202 5.87005 48.7102 7.98008 46.8502 7.79008Z"
        fill="#231F20"
      />
      <path
        d="M48.6903 3.45007C49.0327 3.45007 49.3103 3.17249 49.3103 2.83008C49.3103 2.48766 49.0327 2.21008 48.6903 2.21008C48.3479 2.21008 48.0703 2.48766 48.0703 2.83008C48.0703 3.17249 48.3479 3.45007 48.6903 3.45007Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="13.1584"
          y1="-5.93707"
          x2="13.1584"
          y2="13.2216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
        <linearGradient
          id={randomGradientId2}
          x1="37.9208"
          y1="-5.93705"
          x2="37.9208"
          y2="13.2216"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </g>
  )
}
